<template>
  <h2
    :class="[getFontSizeClass()]"
    class="base-heading"
  >
    {{ text }}
  </h2>
</template>

<script>
import { headingSizes } from './headingSizes';

export default {
  name: 'Heading',
  props: {
    text: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: null,
      validator(value) {
        return [32, 24, 20].includes(value);
      },
    },
  },
  methods: {
    getFontSizeClass() {
      return headingSizes[this.size] || headingSizes[32];
    },
  },
};
</script>

<style lang="scss" scoped>
.base-heading {
  font-weight: var(--ds-font-weight-semibold);
  color: var(--ds-color-text-1);
}

.font-size-xl {
  font-size: var(--ds-font-size-xl);
}

.font-size-lg {
  font-size: var(--ds-font-size-lg);
}

.font-size-md {
  font-size: var(--ds-font-size-md);
}
</style>
